import { BASE_PAGE_NAMES } from '../constants';

/* A generic website screen used inside the device frames. */
export const Shot = ({ src, alt = '', pos = 'left top' }) => (
  <img src={src} alt={alt} className="h-full w-full object-cover" style={{ objectPosition: pos }} loading="lazy" />
);

export const Screen = ({ page = 'Home', dark = false, compact = false, wp = false, arabic = false }) => {
  const ink = dark ? '#fff' : '#1d1d1f';
  const bg = dark ? '#0b0b0c' : '#fff';
  const soft = dark ? '#2a2a2e' : '#E2E8F0';
  return (
    <div className="flex h-full w-full flex-col" style={{ background: bg, color: ink }} dir={arabic ? 'rtl' : 'ltr'}>
      <div className="flex items-center justify-between px-4 py-3">
        <span className="h-2.5 w-14 rounded-full" style={{ background: ink }} />
        {!compact && (
          <div className="flex gap-2">
            {BASE_PAGE_NAMES.slice(0, 5).map((p) => (
              <span key={p} className="text-[8px] font-medium" style={{ color: p === page ? '#0F5EFF' : ink, opacity: p === page ? 1 : 0.55 }}>
                {arabic ? { Home: 'الرئيسية', About: 'من نحن', Services: 'الخدمات', Gallery: 'المعرض', Testimonials: 'آراء' }[p] : p}
              </span>
            ))}
          </div>
        )}
        {compact && <span className="h-2 w-5 rounded-sm" style={{ background: soft }} />}
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-2 px-6 text-center">
        <span className="h-3 w-3/4 rounded-full" style={{ background: ink }} />
        <span className="h-3 w-1/2 rounded-full" style={{ background: ink, opacity: 0.85 }} />
        <span className="mt-1 h-1.5 w-2/3 rounded-full" style={{ background: soft }} />
        <span className="h-1.5 w-1/2 rounded-full" style={{ background: soft }} />
        <span className="mt-3 rounded-full bg-[#0F5EFF] px-3 py-1 text-[8px] font-semibold text-white">Get a quote</span>
      </div>
      <div className="grid grid-cols-3 gap-2 px-4 pb-4">
        {[0, 1, 2].map((i) => (
          <span key={i} className="h-10 rounded-lg" style={{ background: soft }} />
        ))}
      </div>
      <div className="flex items-center justify-between px-4 pb-3 text-[7px]" style={{ opacity: 0.6 }}>
        <span>{wp ? 'Powered by WordPress' : 'yourbusiness.com'}</span>
        <span className="rounded-full bg-[#25D366] px-2 py-0.5 font-semibold text-white" style={{ opacity: 1 }}>WhatsApp</span>
      </div>
    </div>
  );
};

export const Laptop = ({ children, className = '' }) => (
  <div className={`relative ${className}`}>
    <div className="overflow-hidden rounded-[18px] border-[6px] border-[#1d1d1f] bg-[#1d1d1f] shadow-[0_40px_90px_-30px_rgba(0,0,0,0.45)]">
      <div className="aspect-[16/9] overflow-hidden rounded-[10px] bg-white">{children}</div>
    </div>
    <div className="mx-auto h-2.5 w-[104%] -translate-x-[2%] rounded-b-xl bg-[#E2E8F0]" />
  </div>
);

export const Phone = ({ children, className = '' }) => (
  <div className={`relative ${className}`}>
    <div className="overflow-hidden rounded-[36px] border-[8px] border-[#1d1d1f] bg-[#1d1d1f] shadow-[0_40px_90px_-30px_rgba(0,0,0,0.45)]">
      <div className="absolute left-1/2 top-2 z-10 h-4 w-20 -translate-x-1/2 rounded-full bg-[#1d1d1f]" />
      <div className="aspect-[9/19] overflow-hidden rounded-[28px] bg-white">{children}</div>
    </div>
  </div>
);
